module.exports = __webpack_public_path__ + "static/media/bottom_logo.db765a29.svg";